import { render, staticRenderFns } from "./thousandsPageBanner.vue?vue&type=template&id=61bc5ed6"
var script = {}
import style0 from "./thousandsPageBanner.vue?vue&type=style&index=0&id=61bc5ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports